import { Component, inject } from "@angular/core";
import { IsNotMobileDirective } from "../../directives/is-not-mobile.directive";
import { AlertHistorySessionService } from "../../../features/alerts/services/alert-history-session.service";
import { RETAILER_LOGO_URL } from "../../../core/utils/app.constants.utils";

@Component({
  selector: "twx-retailer-sidebar-card",
  imports: [IsNotMobileDirective],
  templateUrl: "./retailer-sidebar-card.component.html",
  styleUrl: "./retailer-sidebar-card.component.scss",
})
export class RetailerSidebarCardComponent {
  private readonly alertHistorySession = inject(AlertHistorySessionService);

  /** Shared with the store rows, so the two cannot show different logos. */
  readonly logoUrl = RETAILER_LOGO_URL;

  /**
   * Home unit name from the Alert History entry token (TWX-536): the user's
   * store at store tier, their district/region name above that. Null outside
   * an Alert History session, where the mock placeholder is shown instead.
   */
  get homeName(): string | null {
    return this.alertHistorySession.user?.homeName ?? null;
  }
}
